(function($) {

  var pageId = "page-calendar-event-edit",
    page = '#' + pageId,
    calEvtRequest = null,
    event = null,
    repeat_modify = null;

  $(function() {
    $(document)
      .on("click", ".period-update-confirm .btn", periodSaveDecision)
      .on("click", page + " .btn-save-event", saveEventClick)
      .on("change", page + ' #select-cal', function(e) {
        calChange();
      })

      .on('click', page + ' .cb-visitor-lock', function(e) {
        refreshManageMembers();
      })

      .on('ajax:beforeSend', page + ' form.form-event', function(e, xhr, settings) {
        var memberGuids = $(this).find(".member.selected").map(function() {
          return $(this).data('guid');
        }).get().join(",");
        settings.data += "&member_guids=" + memberGuids +
          "&repeat_modify=" + repeat_modify;
      });
  });

  function refreshManageMembers() {
    var $page = $(page);
    var selectEl = $page.find(".manage-members");
    var opt = $page.find("#select-cal option:selected");
    var memberGuids = opt.data("member-guids") || [];

    var visitorLock = $page.find('.cb-visitor-lock').prop('checked');
    var members = tower.updateManageMembers(selectEl, memberGuids, visitorLock);
    $page.find('.cal-members-field').toggle(members.length > 0);
  }

  function calChange() {
    var $page = $(page);
    var selectEl = $page.find(".manage-members");
    var opt = $page.find("#select-cal option:selected");
    var input = $page.find("[name=caleventable_type]");
    var memberGuids = opt.data("member-guids") || [];

    var visitorLock = false;
    var $visitorLock = $page.find('.visitor-lock');
    var $cbVisitorLock = $visitorLock.find('.cb-visitor-lock');
    if (opt.is("[data-project]")) {
      input.val("Project");
      if (opt.is('[data-guest-lockable]')) {
        $visitorLock.show();
        visitorLock = $cbVisitorLock.prop('checked');
      } else {
        $visitorLock.hide();
        $cbVisitorLock.prop('checked', false);
      }
    } else {
      input.val("Calendar");
      $visitorLock.hide();
      $cbVisitorLock.prop('checked', false);
    }

    var members = tower.updateManageMembers(selectEl, memberGuids, visitorLock);
    $page.find('.cal-members-field').toggle(members.length > 0);
  }

  function isScheduleEvent(event) {
    return $('.cal-event-form').data('schedule');
  }

  function saveEventClick(e) {
    e.preventDefault();

    var btn = $(this),
      form = btn.closest('.form');

    if (isScheduleEvent(event)) {
      var confirmContent = $(simple.tpl($('#tpl-period-update-confirm').html())),
        pointTo = form.find('.repeat-desc');

      simple.popover({
        pointTo: pointTo,
        content: confirmContent
      });
    } else {
      saveEvent(form);
    }
  }

  function periodSaveDecision(e) {
    e.preventDefault();

    var btn = $(this),
      popoverEl = btn.closest('.period-update-confirm'),
      form = $('.cal-event-form .form-event'),
      popover = popoverEl.closest('.simple-popover').data('popover');

    if (btn.is('.btn-yes')) {
      repeat_modify = 1;
      saveEvent(form);
    } else if (btn.is('.btn-no')) {
      repeat_modify = 0;
      saveEvent(form);
    }
    popover.destroy();
  }

  function saveEvent(form) {
    var txtContent = form.find("#txt-event-content"),
      content = $.trim(txtContent.val());

    if (!content) {
      txtContent.addClass("error");
      return;
    } else {
      txtContent.removeClass("error");
    }

    form.trigger('submit');
  }

  var $startMoment = null;
  var $endMoment = null;

  $(document).on('pjaxload#' + pageId, function(e, $page, page) {
    if (calEvtRequest) {
      calEvtRequest.abort();
      calEvtRequest = null;
    }

    calEvtRequest = $.ajax({
      type: "get",
      url: $('.cal-event-form').data("url"),
      dataType: 'json',
      success: function(result) {
        event = result;
        calChange();
      }
    });

    var $eventContent = $page.find("#txt-event-content")
      .on('keydown', function(e) {
        var metaKey = tower.metaKey(e);
        if (e.which == 13 || e.which == 13 && metaKey) {
          e.stopPropagation();
          e.preventDefault();
          $page.find(".btn-save-event").trigger('click');
        }
      })
      .autosize();

    $page.find("#txt-event-desc").autosize();

    tower.selectText($eventContent[0]);

    var $cb = $page.find('.cb-all-day').on('click', function(e) {
      var $cb = $(this);
      var checked = $cb.prop('checked');
      $page.find('.event-time')
        .toggleClass('all-day', checked);
      if ($startMoment) {
        $startMoment.destroy();
      }
      if ($endMoment) {
        $endMoment.destroy();
      }
      initMomentpicker(checked);
    });

    // check whether the event is all day event
    var endTime = moment($('#end_moment').attr('value'));
    if (endTime.isSame(endTime.clone().endOf('day'), 'm')) {
      $cb.trigger('click');
    } else {
      initMomentpicker();
    }

    var $selectRemind = $page.find('#select-remind');
    $selectRemind.val($selectRemind.data('remind-interval'));

    $page.find('.manage-members .member.creator').remove();
    tower.initManageMembers($page);
  });

  function initMomentpicker(checked) {
    var $start_input = $('#start_moment');
    var $end_input = $('#end_moment');
    var start_time = null;
    var end_time = null;

    if (checked) {
      start_time = $start_input.attr('value') ? moment($start_input.attr('value'), 'YYYY-MM-DD THH:mm:ss') : moment()
      end_time = $end_input.attr('value') ? moment($end_input.attr('value'), 'YYYY-MM-DD THH:mm:ss') : moment()
      $start_input.addClass('all-day').removeClass('point-in-time');
      $end_input.addClass('all-day').removeClass('point-in-time');
      start_time.hours(0)
      end_time.minute(0)
      end_time.seconds(0)
      end_time.hours(23)
      end_time.minute(59)
      end_time.seconds(59)
    } else {
      start_time = moment($start_input.attr('value'), 'YYYY-MM-DD THH:mm:ss')
      end_time = moment($end_input.attr('value'), 'YYYY-MM-DD THH:mm:ss')
      $start_input.addClass('point-in-time').removeClass('all-day')
      $end_input.addClass('point-in-time').removeClass('all-day')
    }

    $startMoment = simple.momentpicker({
      el: $start_input,
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      cls: 'calendar-momentpicker'
    });

    $endMoment = simple.momentpicker({
      el: $end_input,
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      cls: 'calendar-momentpicker'
    });

    $startMoment.setMoment(start_time)
    $endMoment.setMoment(end_time)

    $start_input.val($startMoment.getValue())
    $end_input.val($endMoment.getValue())

    var handleTime = function(type) {
      var startTime = $startMoment.getMoment();
      var startTimeStamp = startTime.toDate().getTime();
      var endTimeStamp = $endMoment.getMoment().toDate().getTime();
      // 是否为全天日程
      var allDay = $('.cb-all-day').is(':checked');

      if (startTimeStamp >= endTimeStamp) {
        if (type === 'start') {
          if (allDay) {
            // 86399秒 == 23小时59分59秒
            $endMoment.setMoment($startMoment.getMoment().add(86399, 'seconds'));
          } else {
            $endMoment.setMoment($startMoment.getMoment().add(1, 'hours'));
          }
        } else {
          if (allDay) {
            $startMoment.setMoment($endMoment.getMoment().add(-86399, 'seconds'));
          } else {
            $startMoment.setMoment($endMoment.getMoment().add(-1, 'hours'));
          }
        }
      }
    };

    $startMoment.on('select', function(e, params) {
      handleTime('start');
    });

    $endMoment.on('select', function(e, params) {
      handleTime('end');
    });
  }

})(jQuery);
